export {AuthRegister} from "./AuthRegister";
export {RegisterForm} from "./RegisterForm";
import                     "./styles/index.less";
